import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./register.css";
import logo from "../assets/logo.png";

export default function Register() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const register = e => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!username || !email || !password) {
      setError("All fields are required");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const admins = JSON.parse(localStorage.getItem("admins")) || [];

    if (admins.some(a => a.email === email)) {
      setError("Admin already exists");
      return;
    }

    admins.push({ username, email, password });
    localStorage.setItem("admins", JSON.stringify(admins));

    setSuccess("Registration successful");

    setTimeout(() => navigate("/"), 1200);
  };

  return (
    <div className="auth-body">
      <div className="auth-card">
        <img src={logo} className="auth-logo" alt="NX Optics" />

        <h2>Create Admin Account</h2>
        <p className="auth-sub">Register to access admin panel</p>

        <form onSubmit={register}>
          <input
            placeholder="Full Name"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
          />

          <button type="submit">Register</button>
        </form>

        {error && <div className="auth-error">{error}</div>}
        {success && <div className="auth-success">{success}</div>}

        <p className="auth-footer">
          Already have an account? <Link to="/">Login</Link>
        </p>
      </div>
    </div>
  );
}
